import { render, staticRenderFns } from "./social-club-admin.vue?vue&type=template&id=aed66b4c&scoped=true&lang=pug"
import script from "./social-club-admin.js?vue&type=script&lang=js&external"
export * from "./social-club-admin.js?vue&type=script&lang=js&external"
import style0 from "./social-club-admin.vue?vue&type=style&index=0&id=aed66b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed66b4c",
  null
  
)

export default component.exports